import { Mark, mergeAttributes } from '@tiptap/core';

const AIHighlight = Mark.create({
  name: 'aiHighlight',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      category: {
        default: null,
        parseHTML: element => element.getAttribute('data-ai-category'),
        renderHTML: attributes => {
          if (!attributes.category) {
            return {};
          }
          return {
            'data-ai-category': attributes.category,
          };
        },
      },
    };
  },

  parseHTML() {
    // DISABLED: Don't parse HTML marks back into editor marks
    // This prevents highlights from persisting across page refreshes via Y.js
    return [];
  },

  renderHTML({ HTMLAttributes }) {
    const category = HTMLAttributes['data-ai-category'];

    // Map categories to background colors matching Figma design
    const colorMap = {
      'ai_generated': '#F2E8CF',
      'ai_paraphrased': '#DFD3FC',
      'human_paraphrased': '#D0E0FD',
      'content_similarity': '#FDD0D0',
      'human_written': 'transparent',
    };

    const backgroundColor = colorMap[category] || 'transparent';
    const className = `ai-highlight-${category}`;

    return [
      'mark',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        class: className,
        style: `background-color: ${backgroundColor} !important; padding: 2px 4px; border-radius: 3px; display: inline;`,
      }),
      0,
    ];
  },

  addCommands() {
    return {
      setAIHighlight: (category) => ({ commands }) => {
        return commands.setMark(this.name, { category });
      },
      toggleAIHighlight: (category) => ({ commands }) => {
        return commands.toggleMark(this.name, { category });
      },
    };
  },
});

export default AIHighlight;
